// import { Colors } from 'themes';

const createMapOptions = maps => {
  return {
    panControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    zoomControl: true,
    zoomControlOptions: {
      position: maps.ControlPosition.LEFT_CENTER,
    },
    scrollwheel: false,
    styles: [
      // { elementType: 'geometry', stylers: [{ color: Colors.silver }] },
      { elementType: 'labels.text.stroke', stylers: [{ visibility: 'off' }] },
      { elementType: 'labels', stylers: [{ visibility: 'off' }] },
      {
        featureType: 'administrative.locality',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },

      // {
      //   featureType: 'road',
      //   elementType: 'geometry',
      //   stylers: [{ color: Colors.white }],
      // },
      // {
      //   featureType: 'road',
      //   elementType: 'labels',
      //   stylers: [{ visibility: 'off' }],
      // },

      {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },

      // {
      //   featureType: 'water',
      //   elementType: 'geometry',
      //   stylers: [{ color: Colors.white }],
      // },
      {
        featureType: 'water',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [{ visibility: 'off' }],
      },
    ],
  };
};

export default createMapOptions;
